import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AuthRoutingModule } from './auth/auth-routing.module';
import { MainRoutingModule } from './main/main-routing.module';
import { AccountRoutingModule } from './account/account-routing.module';
import { OthersRoutingModule } from './others/others-routing.module';
import { FinanceRoutingModule } from './finance/finance-routing.module';

import { AppComponent } from './app.component';
import { AlertService } from 'src/app/services/alert.service';

import { HttpClientModule } from '@angular/common/http';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { IonicStorageModule } from '@ionic/storage';
import { FileOpener } from '@ionic-native/file-opener/ngx';

import { ComponentsModule } from './components/components.module';

// import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/environment';

declare global {
  interface Window {
    opera: any;
  }
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        AuthRoutingModule,
        MainRoutingModule,
        AccountRoutingModule,
        OthersRoutingModule,
        FinanceRoutingModule,
        HttpClientModule,
        IonicStorageModule.forRoot({
            name: '__veedodb',
            driverOrder: ['sqlite', 'indexeddb', 'websql']
        }),
        ComponentsModule,
        ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production })
    ],
    providers: [
        StatusBar,
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        NativeStorage,
        AlertService,
        FileOpener,
        // OneSignal,
        // GoogleAnalytics,
        // FirebaseAnalytics,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
